import { Box, styled } from "@mui/material";

export const InputFieldWrapperDiv = styled(Box)(({ theme }) => ({
    width: "400px",
    [theme.breakpoints.down("md")]: {
        width: "320px"
    }
}))